import React from "react";
import swal from "sweetalert";
import {BASE_URL} from "./utility";
import MenuBar from "./navbar";
import SocialMediaLinks from "./socialmedialinks";
import Header from './header';
class NameForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {username: '',password:''};
    this.handleUserChange = this.handleUserChange.bind(this);
    this.handlePassChange = this.handlePassChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  
  handleUserChange(event) {
    this.setState({username: event.target.value});
  }

  handlePassChange(event) {
    this.setState({password: event.target.value});
  }
  handleSubmit(event) {
    event.preventDefault();
     fetch(BASE_URL+'login', {
   method: 'post',
   headers: {'Content-Type':'application/json'},
   body:  JSON.stringify({
    "username": this.state.username,
    "password": this.state.password
   })}).then((response) => response.json())
   .then((responseJson) => {
     if (responseJson.result === 'success')
     {
      localStorage.setItem("token",responseJson.token)
      window.location.href = '/operations';
     }else
     {
      swal(responseJson.message);
     }

   })
    .catch((error) => {
      console.error(error);
    });
 };

  render() {
    return (<div style={{ 
  backgroundImage: `url(${BASE_URL+"download/general/bg"})`, 
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  minHeight: '100vh',
  display: 'flex', 
  flexDirection: 'column',
  justifyContent: 'space-between'
}}>
  
  <Header />

  <center><MenuBar /></center>

  <div style={{ 
    flex: 1,
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    padding: '40px 20px'
  }}>
    <form 
      className="Auth-form" 
      onSubmit={this.handleSubmit} 
      style={{ 
        background: "#fff", 
        borderRadius: "15px",
        padding: "30px 40px",
        width: "100%", 
        maxWidth: "400px", 
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
      }}
    >
      <div className="Auth-form-content">
        <h3 style={{ 
          textAlign: 'center', 
          color: "#333", 
          marginBottom: "25px",
          fontWeight: '600'
        }}>
          Sign In
        </h3>

        <div className="form-group mt-3">
          <input
            type="text"
            className="form-control mt-1"
            placeholder="Enter username"
            style={{
              width: "100%",
              padding: "12px 15px",
              borderRadius: "8px",
              border: "1px solid #ccc"
            }}
            value={this.state.username}
            onChange={this.handleUserChange}
          />
        </div>

        <div className="form-group mt-3">
          <input
            type="password"
            className="form-control mt-1"
            placeholder="Enter password"
            style={{
              width: "100%",
              padding: "12px 15px",
              borderRadius: "8px",
              border: "1px solid #ccc"
            }}
            value={this.state.password}
            onChange={this.handlePassChange}
          />
        </div>

        <div style={{ 
          marginTop: "25px",
          display: 'flex', 
          justifyContent: 'center'
        }}>
          <button 
            type="submit" 
            className="btn btn-primary"
            style={{ 
              padding: "12px 30px", 
              fontWeight: "600",
              borderRadius: "8px",
              backgroundColor: "#007bff",
              border: "none"
            }}
          >
            Login
          </button>
        </div>
      </div>
    </form>
  </div>

  <div style={{ padding: '20px 0' }}>
    <SocialMediaLinks />
  </div>

</div>
 );
  }
}

export default NameForm;